// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class QpsignatureItem {
    static getAttributeTypeMap() {
        return QpsignatureItem.attributeTypeMap;
    }
}
QpsignatureItem.discriminator = undefined;
QpsignatureItem.additionalProperties = false;
QpsignatureItem.attributeTypeMap = [
    {
        "name": "text",
        "baseName": "text",
        "type": "string"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
];
//# sourceMappingURL=qpsignatureItem.js.map